import axios from 'axios';
import {API_URL} from '../config/constants';
import {AgentChatRequest, AgentChatResponse, ApplyProposalRequest, ProposalDecisionRequest} from '../@types/agent';
import {InvestigationDTO} from '../@types/agent-investigation';
import EventSequence from '../@types/event-sequence';
import EventSequenceService from './event-sequence.service';

const OPTIONS = {withCredentials: true, headers: {'Content-Type': 'application/json'}};

/** The safety view assistant: one turn at a time, plus the decisions the analyst makes on its proposals. */
class AgentService {
    execute(request: AgentChatRequest): Promise<AgentChatResponse> {
        return axios.post<AgentChatResponse>(`${API_URL}api/v2/agents/execute`, request, OPTIONS)
            .then((response) => response.data);
    }

    /**
     * Starts a turn off the request thread and returns the investigation to poll, so the reader
     * watches the work happen. Same request as execute.
     */
    ask<M = Record<string, unknown>>(request: AgentChatRequest): Promise<InvestigationDTO<M>> {
        return axios.post<InvestigationDTO<M>>(`${API_URL}api/v2/agents/investigations`, request, OPTIONS)
            .then((response) => response.data);
    }

    /** The investigation as it stands: the steps so far, and the answer once there is one. */
    progress<M = Record<string, unknown>>(id: string): Promise<InvestigationDTO<M>> {
        return axios.get<InvestigationDTO<M>>(`${API_URL}api/v2/agents/investigations/${encodeURIComponent(id)}`, OPTIONS)
            .then((response) => response.data);
    }

    /** Applies an accepted proposal server-side and returns the updated safety view for the canvas. */
    applyProposal(request: ApplyProposalRequest): Promise<EventSequence> {
        return axios.post(`${API_URL}api/v2/agents/proposals/apply`, request, OPTIONS)
            .then((response) => EventSequenceService.formEventSequencePromise(response.data));
    }

    recordRejection(request: ProposalDecisionRequest): Promise<void> {
        return axios.post(`${API_URL}api/v2/agents/proposals/decision`, request, OPTIONS)
            .then((): void => undefined);
    }
}

export default new AgentService();
